
//#region 猜暗号
export interface CharadeInterface{
    head:string,
    chats:string[],
    answer:string,
    rotation:number
} 
//#endregion

export interface CharadeLevelInterface{
    levelDatas:CharadeInterface[];
    levelSelectFonts:string
}

let levels:CharadeLevelInterface[] = null;

export default function(){
    if(!levels){
        levels = [
            {
                levelDatas:[
                    {head:"1",chats:["#14","#15"],answer:"在家吗",rotation:0},
                    {head:"1",chats:["#14"],answer:"在家",rotation:1},
                    {head:"1",chats:["#15","#15","#15"],answer:"在干嘛",rotation:0},
                    {head:"1",chats:["#2","#13"],answer:"在家准备睡觉",rotation:1},
                    {head:"1",chats:["#1","#6","#4","#15"],answer:"去喝酒",rotation:0},
                    {head:"1",chats:["#8","#11","#8","#3"],answer:"没帅哥不去",rotation:1},
                    {head:"1",chats:["#11","#11","#11","#11","#16"],answer:"四个你喜欢的类型",rotation:0},
                    {head:"1",chats:["#10","#9"],answer:"化妆了走",rotation:1},
                    {head:"1",chats:["#7","#12"],answer:"几点",rotation:0},
                    {head:"1",chats:["#17","#12","#12","#12"],answer:"下午三点",rotation:1},
                    {head:"1",chats:["#5","#5"],answer:"成交",rotation:0},
                    {head:"1",chats:["#5","#5"],answer:"成交",rotation:1},
                ],
                levelSelectFonts:"在你的在睡觉家点喜四喝类吗备家在干嘛在家准去酒没帅哥不去个欢型化妆了走几点下午三点成交成交好玩吗放鸽子了还在喝吗上酒开门"
            },
            {
                levelDatas:[
                    {head:"1",chats:["#17","#32","#31","#15"],answer:"下网课了",rotation:0},
                    {head:"1",chats:["#17","#36"],answer:"下了",rotation:1},
                    {head:"1",chats:["#35","#18","#28"],answer:"打游戏吗",rotation:0},
                    {head:"1",chats:["#35","#29","#35","#7"],answer:"王者还是吃鸡",rotation:1},
                    {head:"1",chats:["#22","#25","#15"],answer:"农药",rotation:0},
                    {head:"1",chats:["#27"],answer:"可",rotation:1},
                    {head:"1",chats:["#7","#19","#15"],answer:"几排",rotation:1},
                    {head:"1",chats:["#30","#30","#19"],answer:"双排",rotation:0},
                    {head:"1",chats:["#8","#20","#26","#21"],answer:"不可路人有毒",rotation:1},
                    {head:"1",chats:["#30","#30","#30","#30","#30","#19"],answer:"五排",rotation:0},
                    {head:"1",chats:["#37","#34","#24"],answer:"ok我野王露露",rotation:0},
                    {head:"1",chats:["#33","#23","#38"],answer:"发车我跟班瑶",rotation:1},
                ],
                levelSelectFonts:"下人打吃下五课双网露了药了可班游戏吗王者还是鸡农几排排不可路人有毒排我野王露ok发车我跟瑶面国都射开啊我是服手对很菜就是"
            },
            {
                levelDatas:[
                    {head:"1",chats:["#41"],answer:"有毛病吧",rotation:0},
                    {head:"1",chats:["#41"],answer:"不好玩吗",rotation:1},
                    {head:"1",chats:["#46"],answer:"一点都不",rotation:0},
                    {head:"1",chats:["#40","#40"],answer:"好吧",rotation:1}
                ],
                levelSelectFonts:"玩病点不毛好吗好不吧有无一都吧语"
            },
            {
                levelDatas:[
                    {head:"1",chats:["#43"],answer:"出去玩",rotation:0},
                    {head:"1",chats:["#40","#40","#40","#40"],answer:"我想想",rotation:1},
                    {head:"1",chats:["#45","#43"],answer:"几点走",rotation:1},
                    {head:"1",chats:["#39","#44"],answer:"12点走",rotation:0},
                    {head:"1",chats:["#45"],answer:"ok",rotation:1}
                ],
                levelSelectFonts:"出点o说几21k我想点去玩走想的走"
            }
        ]
    }
    return levels;
}